import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setCustomerFromCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        setCustomerFromCallback(user);
        // strip the hash so refreshes don't re-run this
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setCustomerFromCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream text-forest">
      <div className="text-sm tracking-widest uppercase" data-testid="auth-callback-loading">
        Signing you in…
      </div>
    </div>
  );
}
